<template>
  <div class="multiple-bubble-container">
    <vv-checkbox-bubble
      v-for="response in expectedResponseChoices"
      :key="response"
      :label="choices[response].label"
      disabled
    />
  </div>
</template>

<script>
import { VvCheckboxBubble } from '@/components/common'

export default {
  name: 'MultipleBubble',
  components: { VvCheckboxBubble },
  props: {
    choices: {
      type: Array,
      required: true
    },
    expectedResponse: {
      type: Object,
      required: true
    }
  },
  computed: {
    expectedResponseChoices() {
      return this.expectedResponse.choices.filter(choiceId => this.choices[choiceId])
    }
  }
}
</script>

<style lang="scss" scoped>
.multiple-bubble-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
</style>
